import { render, staticRenderFns } from "./MultiSelect.vue?vue&type=template&id=dd375bf4&scoped=true"
import script from "./MultiSelect.vue?vue&type=script&lang=js"
export * from "./MultiSelect.vue?vue&type=script&lang=js"
import style0 from "./MultiSelect.vue?vue&type=style&index=0&id=dd375bf4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd375bf4",
  null
  
)

export default component.exports